<template>
  <div class="px-2" data-no-row-click>
    <a-switch size="small" :checked="isEnabled" :loading="isUpdating" :disabled="isUpdating" @change="handleSwitchChange" />
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { message } from "ant-design-vue";
import CustomEventService from "@/src/api/CustomEventService.js";

const props = defineProps({
  row: { type: Object, required: true },
});

const isEnabled = ref(props.row?.status === "active");
const isUpdating = ref(false);

const handleSwitchChange = async (checked) => {
  if (isUpdating.value) return;
  isUpdating.value = true;
  const previousStatus = isEnabled.value;
  isEnabled.value = checked;

  try {
    const response = await CustomEventService.updateCustomEvent(props.row.id, {
      status: checked ? "active" : "draft",
    });

    if (response?.success) {
      message.success(`Custom event ${checked ? "enabled" : "disabled"}`);
    } else {
      isEnabled.value = previousStatus;
      message.error("Failed to update status");
    }
  } catch (error) {
    isEnabled.value = previousStatus;
    console.error("Error updating custom event status:", error);
    message.error("An error occurred while updating status");
  } finally {
    isUpdating.value = false;
  }
};

watch(
  () => props.row?.status,
  (newVal) => (isEnabled.value = newVal === "active"),
  { immediate: true },
);
</script>